import React, { useEffect, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { Button, Checkbox, Col, Row } from "antd";
import CurrentTierProgress from "./CurrentTierProgress/CurrentTierProgress";
import StreakCard from "./StreakCard/StreakCard";
import LeaderBored from "./LeaderBored/LeaderBored";
import ColumnChart from "./Charts/ColumnChart";
import TableWithProgress from "./Table/ProgressTable";
import HeatmapChart from "./Charts/HeatMapChart";
import DevelopmentJourneyChart from "./Charts/DevelopmentJourneyChart";
import ChallengesTeams from "./ChallengesTeams/ChallengesTeams";
import RecommendedCard from "./RecommendedBox/RecommendedCard";
import Challenges from "./Challenges/Challenges";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import RecommendedAssesment from "./RecommendedBox/RecomendedAssestment";
import ProfileCompletionWidget from "./ProfileCompletions/ProfileCompletionWidget";
import StatsRadial from "./Profile/StatsRadial";
import DashboardCarousel from "./Carousel/DashboardCarousel";
import { profileCompletionSlice } from "../slices/userSlice";

const ResponsiveGridLayout = WidthProvider(Responsive);
 
const MyAllComponents = [
  {
    title: "Recommended Courses",
    item: <RecommendedCard />,
    key: "1",
    // xl: { i: "1", w: 10, h: 5, x: 0, y: 0 },
    lg: { i: "1", w: 6, h: 3, x: 0, y: 0 },
    md: { i: "1", w: 6, h: 3, x: 0, y: 0 },
    checked: true,
  },

  {
    title: "Recommended Assessment",
    item: <RecommendedAssesment />,
    key: "2",
    // xl: { i: "2", w: 10, h: 5, x: 10, y: 0 },
    lg: { i: "2", w: 6, h: 3, x: 4, y: 0 },
    md: { i: "2", w: 6, h: 3, x: 4, y: 0 },
    checked: true,
  },
  {
    title: "Profile Completion",
    item: <ProfileCompletionWidget />,
    key: "3",
    lg: { i: "3", w: 6, h: 3, x: 0, y: 2 },
    md: { i: "3", w: 6, h: 3, x: 0, y: 2 },
    checked: true,
  },
  {
    title: "Recent Activity",
    item: <TableWithProgress />,
    key: "4",
    lg: { i: "4", w: 6, h: 3, x: 4, y: 2 },
    md: { i: "4", w: 6, h: 3, x: 4, y: 2 },
    checked: true,
  },
  {
    title: "Radial Graph",
    item: <StatsRadial />,
    key: "5",
    lg: { i: "5", w: 6, h: 3, x: 0, y: 4 },
    md: { i: "5", w: 6, h: 3, x: 0, y: 4 },
    checked: true,
  },
  // {
  //   title: "Activity Heat map",
  //   item: (
  //     <div className="h-full">
  //       <HeatmapChart />
  //     </div>
  //   ),
  //   key: "6",
  //   lg: { i: "6", w: 6, h: 3, x: 0, y: 7 },
  //   md: { i: "6", w: 6, h: 3, x: 0, y: 7 },
  //   checked: true,
  // },
  // {
  //   title: "Development Journey",
  //   item: (
  //     <div className="h-full">
  //       <DevelopmentJourneyChart />
  //     </div>
  //   ),
  //   key: "7",
  //   lg: { i: "7", w: 6, h: 3, x: 4, y: 4 },
  //   md: { i: "7", w: 6, h: 3, x: 4, y: 4 },
  //   checked: true,
  // },
  // {
  //   title: "Challenges Teams",
  //   item: <ChallengesTeams />,
  //   key: "8",
  //   lg: { i: "8", w: 10, h: 2, x: 0, y: 11 },
  //   md: { i: "8", w: 10, h: 2, x: 0, y: 11 },
  //   checked: true,
  // },
  // // {
  // //   title: "Recommended Course",
  // //   item: <RecommendedCard />,
  // //   key: "9",
  // //   lg: { i: "9", w: 6, h: 2, x: 4, y: 13 },
  // //   md: { i: "9", w: 6, h: 2, x: 4, y: 13 },
  // //   checked: true,
  // // },
  // {
  //   title: "Challenges",
  //   item: <Challenges />,
  //   key: "10",
  //   lg: { i: "10", w: 6, h: 2, x: 0, y: 15 },
  //   md: { i: "10", w: 6, h: 2, x: 0, y: 15 },
  //   checked: true,
  // },
];

const initialLayouts = {
  // xl: MyAllComponents.map((item) => item.xl),
  lg: MyAllComponents.map((item) => item.lg),
  md: MyAllComponents.map((item) => item.md),
  // lg: [{ i: 'a', x: 0, y: 0, w: 2, h: 2 }, { i: 'b', x: 2, y: 0, w: 4, h: 2 }, { i: 'c', x: 6, y: 0, w: 2, h: 2 }],
  // md: [{ i: 'a', x: 0, y: 0, w: 2, h: 2 }, { i: 'b', x: 2, y: 0, w: 3, h: 2 }, { i: 'c', x: 5, y: 0, w: 2, h: 2 }],
  // Add more breakpoints as needed (sm, xs, etc.)
};

const NewWidget = () => {
  const [layouts, setLayouts] = useState(initialLayouts); // initialLayouts
  const [checkedStates, setCheckedStates] = useState(MyAllComponents);
  const location = useLocation();
  const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
  console.log("🚀 ~ Dashboard ~ location:", location);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const modalIsOpen = useSelector((state) => state.modal.isModalOpen);
  const dispatch = useDispatch();

  const profileCompletionData = async () => {
    try {
      const data = await dispatch(profileCompletionSlice());
      console.log("🚀 ~ Dashboard ~ data:", data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    profileCompletionData();
  }, []);

  useEffect(() => {
    if (localStorage) {
      let prevLayout = localStorage.getItem("dashboard_rgl");
      if (prevLayout) {
        prevLayout = JSON.parse(prevLayout);
        console.log(prevLayout, " = prevLayoutttttttttttt");
      } else {
        prevLayout = initialLayouts;
      }
      setLayouts(prevLayout);
    }
  }, []);

  // const onLayoutChange = (layout, oldLayouts) => {
  //   console.log(oldLayouts, " = layouts:alqama");
  //   console.log(layout, " = layout:alqama");
  //   // let updatedLayout = { lg: layout, md: layout };
  //   let updatedLayout = { xl: layout, lg: layout, md: layout };
  //   if (localStorage) {
  //     const old_localStorage_layout = localStorage?.getItem("dashboard_rgl");
  //     updatedLayout = JSON.parse(old_localStorage_layout);
  //     const isSame = old_localStorage_layout === JSON.stringify(updatedLayout);
  //     if (!isSame) {
  //       localStorage.setItem("dashboard_rgl", JSON.stringify(updatedLayout));
  //     }
  //   }
  //   setLayouts(updatedLayout);
  // };

  const onLayoutChange = (newLayout, oldLayouts) => {
    // console.log(oldLayouts, " = layouts:alqama");
    // console.log(newLayout, " = layout:alqama");
    let updatedLayout = { [currentBreakpoint]: newLayout };
    if (localStorage) {
      const old_localStorage_layout = JSON.parse(
        localStorage?.getItem("dashboard_rgl") || "{}"
      );
      setLayouts((prev) => {
        localStorage.setItem(
          "dashboard_rgl",
          JSON.stringify({
            ...prev,
            ...old_localStorage_layout,
            ...updatedLayout,
          })
        ); 
        return { ...prev, ...old_localStorage_layout, ...updatedLayout };
      });
    }
  };

  const onBreakpointChange = (newBreakpoint) => {
    setCurrentBreakpoint(newBreakpoint);
  };

  const handleCheckboxChange = (index, isChecked) => {
    console.log({isChecked})
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index].checked = isChecked;
    setCheckedStates(newCheckedStates);
  };

  console.log({modalIsOpen})

  const renderCheckboxes = () => {
    return checkedStates.map((state, index) => (
      <div
        key={index}
        className="bg-[#8F8F8F1F] p-3 flex flex-col gap-12 justify-center items-center cursor-pointer"
      >
        <h1 className="font-semibold text-xl">{state.title}</h1>
        <Checkbox
          // className="space-y-10"
          // key={index}
          checked={state.checked}
          onChange={(e) => handleCheckboxChange(index, e.target.checked)}
        >
          <div>{state.item}</div>
          {/* <img src={state.image} alt={`image${index}`} /> */}
        </Checkbox>
      </div>
    ));
  };

  const gridItemStyle = {
    width: "100%", // Remove if you have specific width calculations
    height: "100%",
    background: `#${Math.random().toString(16).slice(2, 8)}`,
    // Add other necessary styles, but avoid interfering with draggability
  };

  return (
    <div className="lg:min-w-[920px] md:max-w-[700px]">
      <div className="mx-2">
       {modalIsOpen && <DashboardCarousel /> } 
      </div>

      {modalIsOpen ? (
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts}
          breakpoints={{
            // xl: 1600,
            lg: 1200,
            md: 996,
            sm: 768,
            xs: 480,
            xxs: 0,
          }}
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          onLayoutChange={onLayoutChange}
          onBreakpointChange={onBreakpointChange}
        >
          {checkedStates?.map((comp) => {
            if (comp.checked) {
              return <div key={comp.key}>{comp.item}</div>;
            }
            return <></>;
          })}
        </ResponsiveGridLayout>
      ) : (
        <div className="m-10 space-y-3 space-x-3">{renderCheckboxes()}</div>
      )}
    </div>
  );
};

export default NewWidget;
